<template>
  <div class="options-container">
    <div v-for="token in tokens" :key="token.label">
      <label class="group-name">{{ token.label }}</label>
      <div>
        <div v-for="option in token.value" :key="option.label" class="row">
          <label>{{ option.label }}</label>
          <span>{{ option.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import upperfirst from 'lodash.upperfirst';
import { getDump } from '@/services/system';

export default {
  data() {
    return {
      dump: {},
    };
  },
  async mounted() {
    this.dump = await getDump();
  },
  computed: {
    tokens() {
      return Object.entries(this.dump).map(this.entryToGroup);
    },
  },
  methods: {
    entryToGroup([key, value]) {
      return {
        label: this.toLabel(key),
        value: Object.entries(value).map(this.entryToItem),
      };
    },
    entryToItem([key, value]) {
      return {
        label: this.toLabel(key),
        value,
      };
    },
    toLabel(key) {
      return upperfirst(key.split(/(?=[A-Z])/).join(' '));
    },
  },
};
</script>

<style lang="scss" scoped>
.options-container {
  width: 460px;
}

.row {
  margin: 20px 10px;
  display: flex;
  justify-content: space-between;
}

.group-name {
  font-weight: bold;
}
</style>
